<template>
  <div class="popup_index_warp">
    <van-popup round  v-model="value" closeable position="bottom"  @close="$emit('update:value',false)">
      <div class="address_index-warp">
        <div class="title">
          <strong style="line-height:1rem">收货地址确认</strong>
          <div class="address_info_item">
             <img class="img" src="@/assets/image/icon_add@3x.png" alt />
             <div class="address_info_info">
               <p class="p1">{{receiverAddressInfo.userName}} {{receiverAddressInfo.mobile}}</p>
               <p class="p2">{{receiverAddressInfo.areaName + receiverAddressInfo.addressDetail}}</p>
             </div>
          </div>
          <!-- <div class="address_info_price">合计运费：￥8.00</div> -->
        </div>
        <div class="adderss_index-btn">
          <van-button class="bt bd"  round @click="submitRouter">地址选错了</van-button>
          <van-button class="bt be" round @click="submitOk">确认无误</van-button>
        </div>
      </div>
    </van-popup>
  </div>  
</template>
<script>
import Util from "@/utils/common";
export default {
  data(){
    return{
      addressDetails:{},
      showD:true
    }
  }, 
  props:{
    subOrderId:{
      default:0,
    },
    addressId:{
      default:0,
    },
    value:{
      default:false
    },
    type:{
      default:'bees',
      type:String
    },
    receiverAddressInfo:{
      default:function(){return{}},
      type:Object
    },
    comePageName:{
      default:'',
      type:String
    },
  },
  methods:{
    submitOk(item){
      this.$emit('closeModal',true)
    },
    submitRouter(){
      if(this.comePageName && this.comePageName == 'refundCommodity'){
        this.$emit('update:value',false);
        let url = location.origin + "/h5user/myaddress";
        Util.jumpToNewPage({
          url: url,
          noTitle: 0
        });
      }else{
        this.$emit('closeModal',false);
        sessionStorage.setItem('submitRouter',1);
        localStorage.removeItem('chosenAddressId');
        this.$router.push({
          name: 'myaddress'
        })
      }
    }
  },
  computed: {},
}
</script>
<style lang="less" scoped>
  .popup_index_warp{
    .van-popup--bottom.van-popup--round {
      border-radius: .2605rem .2605rem 0 0 !important;
    }
    .address_index-warp{
      text-align: left;
      padding: 20px;
      strong{
        font-size: 32px;
        color: #333;
        padding-left: 10px;
      }
      .address_info_item{
        display: flex;
        justify-content: flex-start;
        padding: 30px;
        margin-top: 80px; 
        align-items: center;
        background-color: #f7f7f7;
        border-radius: 10px;
        .img{
          width: 80px;
          height: 80px;
          object-fit: cover;
          margin-right: 20px;
        }
        .address_info_info{
          text-align: left;
          .p1{
            color: #333;
            font-size: 26px;
            padding-bottom: 10px;
          }
          .p2{
            font-size: 24px;
            color: #999;
          }
        }
      }
      .address_info_price{
        text-align: right;
        padding-top: 14px;
        font-size: 26px;
        color: #999;
        padding-bottom: 20px;
      }
      .adderss_index-btn{
        padding-top: 100px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .bt{
          width: 300px;
          height: 72px;
        }
        .bt.bd{
          background-color: #ffffff;
          color: #999999;
          border-color: #999999;
        }
        .bt.be {
          background-color: var(--buttonColor);
          border-color: var(--buttonColor);
          color: var(--textColor);
        }
      }
      .dese{
        color: #F8A651;
        font-size: 26px;
      }
    }
  }
</style>